import { render, staticRenderFns } from "./StationOrganizationAssignMessage.vue?vue&type=template&id=14b74a5a&scoped=true&"
import script from "./StationOrganizationAssignMessage.vue?vue&type=script&lang=js&"
export * from "./StationOrganizationAssignMessage.vue?vue&type=script&lang=js&"
import style0 from "./StationOrganizationAssignMessage.vue?vue&type=style&index=0&id=14b74a5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b74a5a",
  null
  
)

export default component.exports